import React, { FC, ReactElement, ReactNode } from "react";
import "./HomePanel.scss";
import { svgPath } from "./svg";

const HomePanel:FC<{ children?: ReactNode,className?:string }> = (props)=>{
  return (
    <div className={`home-panel-wrap ${props.className || ''}`}>
      <svg className="svg-clip" xmlns="http://www.w3.org/2000/svg" dangerouslySetInnerHTML={{__html:svgPath}}>
      </svg>
      <div className="home-panel-bg"></div>
      <div className="home-panel">{props.children}</div>
    </div>
  );
}

export default HomePanel;
